import { useEffect, useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
// import { BsFillCartCheckFill, BsFillCartPlusFill } from "react-icons/bs";
import { IoChatbubbles } from "react-icons/io5";
import {
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaTimes,
} from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import Ratings from "../components/Ratings";
import { BsHeart } from "react-icons/bs";
import { BsShareFill } from "react-icons/bs";
import Reviews from "../components/Reviews";
import { get_product } from "../store/reducers/homeReducer";
import {
  // add_to_card,
  messageClear,
  add_to_wishlist,
} from "../store/reducers/cardReducer";
import toast from "react-hot-toast";
// import { PiUserFocus } from "react-icons/pi";
// import { AiFillSetting } from 'react-icons/ai';
// import { TbCameraCog } from "react-icons/tb";

import SEO from "../components/SEO";

const Details = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { product, relatedProducts, moreProducts, seller } = useSelector(
    (state) => state.home,
  );
  const { userInfo } = useSelector((state) => state.auth);
  const { errorMessage, succesmdessage } = useSelector((state) => state.card);
  const [totalReview, setTotalReview] = useState(0);
  const [activeImage, setActiveImage] = useState("");
  const [image, setImage] = useState("");
  const [showShare, setShowShare] = useState(false);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    mdmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xmdobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };

  const [quantity, setQuantity] = useState(1);

  const inc = () => {
    if (quantity >= product.stock) {
      toast.error("Out of stock");
    } else {
      setQuantity(quantity + 1);
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // const add_card = () => {
  //   if (userInfo) {
  //     dispatch(
  //       add_to_card({
  //         userId: userInfo.id,
  //         quantity,
  //         productId: product._id,
  //       }),
  //     );
  //   } else {
  //     navigate("/login");
  //   }
  // };

  const add_wishlist = () => {
    if (userInfo) {
      dispatch(
        add_to_wishlist({
          userId: userInfo.id,
          productId: product._id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          discount: product.discount,
          rating: product.rating,
          slug: product.slug,
        }),
      );
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    dispatch(get_product(slug));
  }, [slug]);

  useEffect(() => {
    if (product?.images?.length > 0) {
      setActiveImage(product.images[0]);
      setImage(product.images[0]);
    }
  }, [product]);
  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (succesmdessage) {
      toast.success(succesmdessage);
      dispatch(messageClear());
    }
  }, [errorMessage, succesmdessage]);

  // const buy = () => {
  //   let price = 0;
  //   if (product.discount !== 0) {
  //     price =
  //       product.price - Math.floor((product.price * product.discount) / 100);
  //   } else {
  //     price = product.price;
  //   }
  //   const obj = [
  //     {
  //       sellerId: product.sellerId,
  //       shopName: product.shopName,
  //       price: quantity * (price - Math.floor((price * 5) / 100)),
  //       products: [
  //         {
  //           quantity,
  //           productInfo: product,
  //         },
  //       ],
  //     },
  //   ];
  //   navigate("/shipping", {
  //     state: {
  //       products: obj,
  //       price: price * quantity,
  //       shipping_fee: 85,
  //       items: 1,
  //     },
  //   });
  // };

  const shareProduct = () => {
    if (navigator.share) {
      navigator
        .share({
          title: product.name,
          text: `Check out this product: ${product.name}`,
          url: window.location.href,
        })
        .then(() => {
          toast.success("Product shared successfully");
        })
        .catch((error) => {
          // console.log('Error sharing product:', error);
        });
    } else {
      setShowShare(true);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        toast.success("Link copied to clipboard");
        setShowShare(false);
      })
      .catch(() => {
        toast.error("Failed to copy link");
      });
  };

  // const handleLinkClick = () => {
  //   // Navigate to the appropriate route with state including product ID and customization null
  //   navigate(`/product/details/Customize/${product.slug}`, {
  //     state: {
  //       customization: null,
  //       productId: product._id,
  //       product: product,
  //     },
  //   });
  // };

  return (
    <div className="w-full">
      <SEO
        title={product?.name}
        description={product?.description?.substring(0, 160)}
        ogImage={product?.images?.[0]}
        ogTitle={product?.name}
        ogDescription={product?.description?.substring(0, 160)}
      />
      <Headers />
      {/* Page Header */}
      <div className="bg-card py-11 border-b border-primaryLighter">
        <div className="w-full">
          <div className="flex flex-col justify-center items-start container mx-auto">
            <div className="flex justify-center items-center gap-3 mb-1.5 text-sm font-medium text-secondary">
              <span className="hover:text-primary cursor-pointer transition-colors">
                Home
              </span>
              <span className="text-primary">/</span>
              <span className="hover:text-primary cursor-pointer transition-colors">
                Products
              </span>
              <span className="text-primary">/</span>
              <span className="hover:text-primary cursor-pointer transition-colors">
                {product?.category}
              </span>
              <span className="text-primary">/</span>
              <span className="text-primary">{product?.name}</span>
            </div>
            <h2 className="text-4xl font-medium text-primary mb-2">
              {product?.name}
            </h2>
            <p className="text-base">
              {product?.description?.substring(0, 100)}...
            </p>
          </div>
        </div>
      </div>
      <section className="py-14 lg:py-10">
        <div className="w-[85%] md:w-[90%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          <div className="w-full md:w-full bg-card drop-shadow-md rounded-3xl">
            <div className="flex md:flex-col gap-8 md:gap-4 px-10 pt-10 pb-10 md:p-4">
              <div>
                <div className=" md:p-1 md:pt-4 md:w-[100%] md:flex md:justify-center md:items-center">
                  <img
                    className="h-[300px] rounded-[10px] w-[300px]"
                    src={image ? image : product.images?.[0]}
                    alt=""
                  />
                </div>
                <div className="pt-3 w-[300px] md:w-full">
                  {product.images && product.images.length > 1 && (
                    <Carousel
                      autoPlay={false}
                      infinite={true}
                      responsive={responsive}
                      transitionDuration={700}
                    >
                      {product.images.map((img, i) => {
                        return (
                          <div
                            className="md:flex md:items-center md:justify-center px-1"
                            key={i}
                            onClick={() => {
                              setImage(img);
                              setActiveImage(img);
                            }}
                          >
                            <img
                              className={`h-[55px] w-[57px] md:h-[100px] md:w-[100px] rounded-[10px] cursor-pointer transition-all duration-200 ${img === activeImage ? "border-2 border-secondary shadow-md" : "border border-transparent hover:border-gray-300"}`}
                              src={img}
                              alt=""
                            />
                          </div>
                        );
                      })}
                    </Carousel>
                  )}
                </div>
              </div>
              <div className="flex flex-col pt-2 md:pt-0 gap-4">
                <div className="flex">
                  <div className="flex md:hidden justify-start items-center text-md text-secondary w-full">
                    <p>Home</p>
                    <span className="pt-1">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <p to="/">{product.category}</p>
                    <span className="pt-1">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <span>{product.name}</span>
                  </div>
                  <button
                    onClick={shareProduct}
                    className="w-[30px] h-[30px] p-2  text-white flex justify-center items-center bg-secondary rounded-full"
                  >
                    <BsShareFill className="" />
                  </button>
                </div>
                <div className="md:flex sm:justify-center md:justify-center md:gap-8 md:items-center ">
                  <div className="flex items-center  gap-3">
                    <h2 className="text-2xl md:text-lg text-primary font-bold">
                      {product.name}
                    </h2>
                    <span
                      className={`text-${product.stock ? "green" : "red"}-500 ${product.stock ? "bg-green-100" : "bg-red-100"} rounded-[10px] px-2 md:text-sm md:hidden `}
                    >
                      {product.stock ? `In Stock` : "Stock Out"}
                    </span>
                  </div>
                  <button
                    onClick={shareProduct}
                    className="w-[30px] h-[30px] p-2 hover:bg-[#1e2951] fixed right-5 hover:text-white hidden md:flex justify-center items-center bg-slate-300 rounded-full text-white"
                  >
                    <BsShareFill className="" />
                  </button>
                </div>
                <div className=" md:flex hidden justify-center items-center">
                  <span
                    className={`text-${product.stock ? "green" : "red"}-500 ${product.stock ? "bg-green-100" : "bg-red-100"} rounded-[10px] px-2 md:text-sm  justify-center `}
                  >
                    {product.stock ? `In Stock` : "Stock Out"}
                  </span>
                </div>
                <div className="text-secondary">
                  <div className="flex justify-start md:justify-center items-center gap-2">
                    <div className="flex text-xl">
                      <Ratings ratings={product.rating} />
                    </div>
                    <span className="text-secondary">( {totalReview} )</span>
                  </div>
                </div>
                <div className="text-xl  font-semibold items-center flex md:justify-center gap-3 md:gap-2">
                  {product.discount !== 0 ? (
                    <>
                      <h2 className="hidden md:flex text-secondary text-base font-medium">
                        Price :
                      </h2>
                      <div className="flex gap-0">
                        <h2 className="line-through text-md md:text-sm md:font-medium text-secondary/70">
                          Rs.{product.price}{" "}
                        </h2>
                        <span className="text-md md:text-sm  md:font-medium text-secondary/70 ">
                          {" "}
                          (-{product.discount}%)
                        </span>
                      </div>

                      <h2 className="text-primary ">
                        Rs.
                        {product.price -
                          Math.floor((product.price * product.discount) / 100)}
                      </h2>
                    </>
                  ) : (
                    <>
                      <h2 className="hidden md:flex text-secondary text-base font-medium">
                        Price :
                      </h2>
                      <h2 className="text-primary"> Rs.{product.price}</h2>
                    </>
                  )}
                </div>

                {product.stock ? (
                  <>
                    <div className="flex gap-3 md:justify-center items-center">
                      <h2 className="text-secondary ">Quantity :</h2>
                      <div className="flex md:flex rounded-lg bg-card h-[40px] justify-center  items-center text-xl">
                        <div
                          onClick={dec}
                          className="px-6 md:px-5 cursor-pointer "
                        >
                          -
                        </div>
                        <div className="px-5 md:px-4">{quantity}</div>
                        <div
                          onClick={inc}
                          className="px-6 md:px-5 cursor-pointer "
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="flex gap-3 md:justify-center  pb-4  border-b border-secondary/40  ">
                  <Link
                    to={`https://wa.me/${seller.whatsappNumber}?text=${encodeURIComponent(
                      `Hi, I want to buy this product:\n\n*Name:* ${product.name}\n*SKU:* ${product.sku || "N/A"}\n*Price:* Rs.${product.discount > 0 ? product.price - Math.floor((product.price * product.discount) / 100) : product.price}\n*Link:* ${window.location.href}`,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full relative group px-8 py-3 rounded-lg bg-secondary text-white isolation-auto flex items-center justify-center gap-2 drop-shadow-lg hover:shadow-secondary/40 z-10 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-right-full before:hover:right-0 before:rounded-full before:bg-secondary before:-z-10 before:aspect-square before:hover:scale-105 overflow-hidden before:hover:duration-700 font-semibold"
                  >
                    <FaWhatsapp className="text-white group-hover:text-white shrink-0" />{" "}
                    Buy Now via WhatsApp
                  </Link>

                  <div className="flex flex-row items-center justify-center gap-2">
                    <div
                      onClick={add_wishlist}
                      className="h-[45px] w-[45px] flex justify-center items-center cursor-pointer rounded-lg drop-shadow-lg hover:shadow-lg hover:shadow-rose-500/40 bg-rose-500 text-white"
                    >
                      <BsHeart />
                    </div>
                    {/* <div onClick={() => navigate('/product/details/TryOnHijab')} className='h-[45px] w-[45px] flex justify-center items-center cursor-pointer rounded-lg drop-shadow-lg hover:shadow-lg hover:shadow-green-800/40 bg-green-300 text-black'>
                                            <PiUserFocus size={22} />
                                        </div> */}
                  </div>
                </div>
                <p className="text-center text-secondary mt-2 text-sm">
                  To buy this product, click on the WhatsApp button above
                </p>
                {/* <div className='flex items-center md:justify-center md:gap-3 gap-4'>
                                    <Link to={`/product/details/Detect`} >
                                        <div
                                            className="relative group flex items-center justify-center gap-1 md:text-md md:px-4 lg:px-6  px-8 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-green-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-green-500 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                                        >
                                            Detect <TbCameraCog className='text-md md:hidden text-green-700 group-hover:text-green-800' />
                                        </div>
                                    </Link>
                                    {
                                        product.stock && (

                                            <div onClick={handleLinkClick} >
                                                <div
                                                    className="relative group flex gap-1 justify-center md:text-md items-center md:px-4  px-8 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-blue-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-blue-300 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                                                >
                                                    Customize?<AiFillSetting className='text-md md:hidden text-blue-500 group-hover:text-blue-700' />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div> */}
              </div>
            </div>
            {/* {product.stock && (<div className='border my-5 mx-5'></div>)}
                        <div className='flex items-center justify-center md:justify-center md:gap-3 gap-4 md:p-5 pb-5'>
                            {
                                product.stock ? (
                                    <>
                                        <button onClick={buy}
                                            className="w-[40%] relative group flex items-center justify-center gap-1 md:text-md md:px-4 lg:px-6  px-8 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-green-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-green-500 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                                        >
                                            Buy Now <BsFillCartCheckFill className='text-md md:hidden text-green-700 group-hover:text-green-800' />
                                        </button>
                                        <button onClick={add_card}
                                            className="w-[40%] relative group flex gap-1 justify-center md:text-md items-center md:px-4  px-8 py-2 rounded-lg drop-shadow-lg bg-white isolation-auto z-10 border-2 border-blue-300 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-blue-300 before:-z-10 before:aspect-square before:hover:scale-150 overflow-hidden before:hover:duration-700"
                                        >
                                            Add to Cart<BsFillCartPlusFill className='text-md md:hidden text-blue-500 group-hover:text-blue-700' />
                                        </button>
                                    </>
                                ) : null
                            }
                        </div> */}
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="flex flex-wrap">
            <div className="w-[70%] md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                {/* Description Section */}
                <div className="mb-6 pb-6 border-b border-secondary/20">
                  <h3 className="text-2xl font-semibold text-primary mb-4">
                    Description
                  </h3>
                  <p className="text-secondary leading-relaxed">
                    {product.description || "No description available."}
                  </p>
                </div>

                {/* Reviews Section */}
                <div>
                  <h3 className="text-2xl font-semibold text-primary">
                    Reviews
                  </h3>
                  <Reviews
                    product={product}
                    updateTotalReview={setTotalReview}
                  />
                </div>
              </div>
            </div>
            <div className="w-[30%] md-lg:w-full">
              <div className="pl-4 md-lg:pl-0">
                <div className="px-3 py-2 text-primary rounded-xl bg-card">
                  <h2> From {product.shopName}</h2>
                </div>
                <div className="flex flex-col mt-3 rounded-2xl border bg-card">
                  {seller?.image && (
                    <img
                      className="w-full h-[150px] object-cover rounded-2xl mb-2"
                      src={seller.image}
                      alt="seller"
                    />
                  )}
                  <div className="flex flex-col gap-1 p-3">
                    {seller?.whatsappNumber && (
                      <a
                        href={`https://wa.me/${seller.whatsappNumber}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium"
                      >
                        <IoChatbubbles size={20} /> Chat on WhatsApp
                      </a>
                    )}
                    {seller?.phoneNumber && (
                      <div className="flex items-center gap-2 text-secondary">
                        <span className="font-semibold">Phone:</span>{" "}
                        {seller.phoneNumber}
                      </div>
                    )}
                    {seller?.instagramHandle && (
                      <div className="flex items-center gap-2 text-secondary truncate">
                        <span className="font-semibold">Instagram:</span>{" "}
                        {seller.instagramHandle}
                      </div>
                    )}
                    {seller?.facebookHandle && (
                      <div className="flex items-center gap-2 text-secondary truncate">
                        <span className="font-semibold">Facebook:</span>{" "}
                        {seller.facebookHandle}
                      </div>
                    )}
                    {seller?.tiktokHandle && (
                      <div className="flex items-center gap-2 text-secondary">
                        <span className="font-semibold">TikTok:</span>{" "}
                        {seller.tiktokHandle}
                      </div>
                    )}
                    {seller?.websiteStoreLink && (
                      <a
                        href={seller.websiteStoreLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium"
                      >
                        Visit Website
                      </a>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-5 mt-3 rounded-2xl border">
                  {moreProducts.map((p, i) => {
                    return (
                      <Link
                        to={`/product/details/${p.slug}`}
                        className="block group rounded-lg group-hover:shadow-lg hover:bg-gray-200 group-hover:bg-gray-200 transition-all duration-300"
                      >
                        <div className="relative rounded-2xl h-[270px] overflow-hidden ">
                          <img
                            className="w-full object-cover rounded-lg2xl h-full transform scale-100 group-hover:scale-105 transition-all duration-300"
                            src={p.images[0]}
                            alt={p.name}
                          />
                          {p.discount !== 0 && (
                            <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                              {p.discount}%
                            </div>
                          )}
                        </div>
                        <h2 className="text-primary px-2 py-1">{p.name}</h2>
                        <div className="flex px-3 gap-2 py-1">
                          <h2 className="text-primary text-md font-bold">
                            Rs.
                            {p.discount
                              ? p.price -
                                Math.floor((p.price * p.discount) / 100)
                              : p.price}
                          </h2>
                          <div className="flex items-center gap-2">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[90%] lg:w-[90%] h-full mx-auto">
          {relatedProducts > 1 && (
            <h2 className="text-2xl py-8 text-primary">Related Products</h2>
          )}
          <div>
            <Swiper
              slidesPerView="auto"
              breakpoints={{
                1280: {
                  slidesPerView: 3,
                },
                565: {
                  slidesPerView: 2,
                },
              }}
              spaceBetween={30}
              loop={true}
              pagination={{
                clickable: true,
                el: ".custom_bullet",
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {relatedProducts.map((p, i) => {
                return (
                  <SwiperSlide key={i}>
                    <Link
                      to={`/product/details/${p.slug}`}
                      className="block rounded-[20px] group"
                    >
                      <div className="relative rounded-[20px] group h-[270px]">
                        <div className="w-full rounded-[20px] h-full">
                          <img
                            className="w-full object-cover rounded-[20px] h-full"
                            src={p.images[0]}
                            alt={p.name}
                          />
                          <div className="absolute h-full rounded-[20px] w-full top-0 left-0 bg-[#000] opacity-25 group-hover:opacity-50 transition-all duration-500"></div>
                        </div>
                        {p.discount !== 0 && (
                          <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                            {p.discount}%
                          </div>
                        )}
                      </div>
                      <div className="p-4 flex absolute w-full bottom-0 rounded-[20px] md-lg:translate-y-[0px] transform translate-y-[100px] overflow-hidden left-0 bg-slate-900 bg-opacity-10 backdrop-blur-md group-hover:translate-y-[0px] transition-all duration-500 flex-col gap-1">
                        <h2 className="text-card text-lg ">{p.name}</h2>
                        <div className="flex justify-start items-center gap-3">
                          <span className="text-lg text-card font-bold">
                            Rs.
                            {p.discount
                              ? p.price -
                                Math.floor((p.price * p.discount) / 100)
                              : p.price}
                          </span>
                          <div className="flex">
                            <Ratings ratings={p.rating} />
                          </div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          <div className="w-full flex justify-center items-center py-10 md:pb-[30%]">
            <div className="custom_bullet justify-center gap-3 !w-auto"></div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Share Modal */}
      {showShare && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowShare(false)}
        >
          <div
            className="bg-white p-6 rounded-2xl shadow-2xl w-[90%] max-w-md transform transition-all scale-100"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-6 border-b pb-3">
              <h3 className="text-xl font-bold text-gray-800">
                Share this product
              </h3>
              <button
                onClick={() => setShowShare(false)}
                className="text-gray-500 hover:text-red-500 transition-colors"
              >
                <FaTimes size={24} />
              </button>
            </div>

            <div className="grid grid-cols-4 gap-4 mb-6">
              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(`Check out this product: ${product.name} - ${window.location.href}`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all duration-300">
                  <FaWhatsapp size={24} />
                </div>
                <span className="text-xs font-medium text-gray-600">
                  WhatsApp
                </span>
              </a>

              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                  <FaFacebook size={24} />
                </div>
                <span className="text-xs font-medium text-gray-600">
                  Facebook
                </span>
              </a>

              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(product.name)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center text-sky-500 group-hover:bg-sky-500 group-hover:text-white transition-all duration-300">
                  <FaTwitter size={24} />
                </div>
                <span className="text-xs font-medium text-gray-600">
                  Twitter
                </span>
              </a>

              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 group"
              >
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300">
                  <FaLinkedin size={24} />
                </div>
                <span className="text-xs font-medium text-gray-600">
                  LinkedIn
                </span>
              </a>
            </div>

            <div className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg border border-gray-200">
              <MdContentCopy className="text-gray-500 text-xl flex-shrink-0" />
              <input
                type="text"
                readOnly
                value={window.location.href}
                className="bg-transparent border-none outline-none text-sm text-gray-600 w-full truncate"
              />
              <button
                onClick={copyToClipboard}
                className="bg-primary text-white text-xs px-3 py-1.5 rounded-md hover:bg-primary/90 transition-colors font-medium whitespace-nowrap"
              >
                Copy
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Details;
